import {Component, ComponentRef, Input, ViewContainerRef} from '@angular/core';
import {ExampleSJ, Word} from '../../models/word.model';
import {ExamplePopupComponent} from '../example-popup/example-popup.component';
import {DynamicComponentService} from '../../services/dynamic-component/dynamic-component.service';
import {GlobalEventService} from '../../services/global-event/global-event.service';

@Component({
  selector: 'app-word-example-btn',
  template: `
    <button type="button"
            *ngIf="exampleSJ"
            (click)="openExample($event)">
      <i class="ic-speak"></i>
    </button>
  `,
  styles: [
    `
      button {
        width: 2.3rem;
        height: 2.3rem;
        margin: 0.2rem 0;
      }

      .ic-speak {
        background: url("../../../../img/btn_voice.svg") no-repeat center / cover;
        width: 100%;
        height: 100%;

        &.on {
          background: url("../../../../img/btn_recording.gif") no-repeat center / cover;
        }
      }
    `,
  ],
})
export class WordExampleBtnComponent {
  @Input() word: Word | null = null;
  @Input() public exampleSJ: ExampleSJ | null = null;

  private elementRefPopup: ComponentRef<ExamplePopupComponent> | null = null;

  constructor(
    private container: ViewContainerRef,
    private dynamicSvc: DynamicComponentService,
    private globalEventSvc: GlobalEventService,
  ) {

  }

  public openExample(event: MouseEvent): void {
    console.log('app-word-example-btn openExample() click');
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event);

    if (!this.exampleSJ) {
      throw new Error('WordExampleBtnComponent openExample() this.exampleSJ is null');
    }

    this.elementRefPopup = this.dynamicSvc.createComponent(ExamplePopupComponent, this.container);

    this.elementRefPopup.instance.close.subscribe(() => {
      console.log('app-word-example-btn openExample() close');
      this.closePopup();
    });

    this.elementRefPopup.instance.word = this.word;
    this.elementRefPopup.instance.exampleSJ = this.exampleSJ;
    this.elementRefPopup.changeDetectorRef.detectChanges();
  }

  private closePopup(): void {
    if (this.elementRefPopup) {
      this.elementRefPopup.destroy();
      this.elementRefPopup = null;
    }
  }
}
